import React, { useState, useEffect } from 'react';
import './style.css';
import { ToastContainer , toast} from 'react-toastify';
import LoadingSpinner from "../Components/LoadingSpinner";
import { Col, Row, Form } from "react-bootstrap";
import { getPendingData } from "../Utils/utils";
import config from "../config/config";
import { useParams } from "react-router-dom";
import axios from "axios";

const Pending = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState('');
  const [errorData, setErrorData] = useState('');
  const [checkOne, setCheckOne] = useState(false); 
  const [checkTwo, setCheckTwo] = useState(false); 
  const id = useParams();

  const getInstructorDetails = async (id) => {
    var res = await getPendingData(id);
    if (res.status === 200) {
      setData(res.data);
    }
    else if(res.status === 404){
      setErrorData(res.message);
    }
    console.log("Data fetched:", res.message);
  };

  useEffect(() => {
    getInstructorDetails(id?.id);
  }, [id]);

  const acceptPending = async () => {
    if (checkOne && checkTwo) {
      let path = config.siteUrl;
      var result = await axios.post(path + `/classes/accept-reject-instructor`, {
        generated_hash: id?.id,
        status: 1
      }, {
        headers: { 'Content-Type': 'application/json' },
      })
        .then((response) => {
          // return response.data;
          toast.success(response.message);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          return null;
        });
      return result;
    }
  };

  const RejectPending = async () => {
    if (checkOne && checkTwo) {
      let path = config.siteUrl;
      var result = await axios.post(path + `/classes/accept-reject-instructor`, {
        generated_hash: id?.id,
        status: 2
      }, {
        headers: { 'Content-Type': 'application/json' },
      })
        .then((response) => {
          // return response.data;
          toast.success(response.message);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          return null;
        });
      return result;
    }
  };

  const selectedSchedule = "TUE - 15:00 - 17:00&&&FRI - 16:00 - 18:00&&&";
  const schedules = selectedSchedule.split('&&&').filter(Boolean);
  const isButtonsEnabled = checkOne && checkTwo;

  const handleCheckOne = () => {
    if (checkOne) {
      setCheckOne(false); 
    } else {
      setCheckOne(true); 
    }
  };

  const handleCheckTwo = () => {
    if (checkTwo) {
      setCheckTwo(false); 
    } else {
      setCheckTwo(true); 
    }
  };

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <ToastContainer position="top-center" />

      <div>
        {data ? <>
          <div className='box mt-4 mx-4'>
          <Row className="w-100 m-auto class-box">
            <div>Class Number: {data?.COURSE_NUMBER}</div>
          </Row>
          <Row className="w-100 mx-4 mt-4">
            <Col md={12}>
              <p style={{ marginRight: '360px', color: 'blue' }}>
                Dear <span style={{ fontWeight: 'bold' }}>{`${data?.FIRSTNAME} ${data?.LASTNAME} `}</span>,
                if you choose to <span style={{ fontWeight: 'bold' }}>ACCEPT</span> the class, please select ONLY two sessions you would like to conduct the class on and click Accept.
                <span style={{ fontWeight: 'bold' }}>Otherwise</span>, if you wish to reject the class, simply click Reject and you will no longer be assigned to this class.
              </p>
            </Col>
          </Row>
          <Row className="w-100 mx-4">
            <div style={{ fontWeight: 600 }}>
              Class Start Date: {data?.AVAILABLE_START_DATE}
            </div>
          </Row>
          <Row className="w-100 mx-4 mt-1">
            <Form className='dates'>
              <div className='date' style={{ marginBottom: '10px', marginRight: '20px' }}>
                <input 
                  type='checkbox'
                  checked={checkOne}
                  onChange={handleCheckOne}
                />
                <p style={{ marginLeft: '10px', marginTop: '15px' }}>{schedules[0].trim()} EST</p>
              </div>
              <div className='date' style={{ marginBottom: '10px' }}>
                <input 
                  type='checkbox'
                  checked={checkTwo}
                  onChange={handleCheckTwo}
                />
                <p style={{ marginLeft: '10px', marginTop: '15px' }}>{schedules[1].trim()} EST</p>
              </div>
            </Form>
          </Row>
        </div>

        <div className='buttons'>
          <button className='button1' onClick={acceptPending}  disabled={!isButtonsEnabled}>Accept</button>
          <button className='button2' onClick={RejectPending}  disabled={!isButtonsEnabled}>Reject</button>
        </div>
        </> : <>
          <div className='m-4 box2'>
            <div className=' w-100 box-in'>
              <p style={{paddingTop:'8px', marginLeft:'10px'}}>Error!</p>
              </div>
            <div className='data'>
            {errorData}
            </div>
          </div>
        </>}
      </div>
    </>
  );
};

export default Pending;
